import {App} from "@vue/runtime-core"
import {initializeAxios} from "@/services/axios-initializer"
import {initializePrimeVue} from "@/primevue"
import {initializeAppKey} from "@/services/app-key-initializer"

import "@/styles/common.scss"

export const initializeApp = (app: App) => {
    initializeAxios()
    initializePrimeVue(app)
    initializeAppKey()
}
